import { render, staticRenderFns } from "./DualOriginPopView.vue?vue&type=template&id=a5f942a0"
import script from "./DualOriginPopView.vue?vue&type=script&lang=js"
export * from "./DualOriginPopView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports